// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-index-wrapper-bxuea{display:grid;grid-gap:48px}.pages-company-index-wrapper-bxuea.pages-company-index-desktop-bfwsn{grid-template-columns:repeat(3,1fr)}.pages-company-index-pageWrapper-ykqiq{padding-bottom:48px}.pages-company-index-pageWrapper-ykqiq.pages-company-index-mobile-bjqkf{padding-top:48px}.pages-company-index-link-bugad{color:#111;display:block;text-decoration:none}.pages-company-index-link-bugad:hover{color:var(--color-primary-hover)}.pages-company-index-title-bufyq{font-size:20px;font-weight:700;text-align:center}.pages-company-index-image-bbcqc{border-radius:6px;height:auto!important;margin-bottom:12px;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-company-index-wrapper-bxuea",
	"desktop": "pages-company-index-desktop-bfwsn",
	"pageWrapper": "pages-company-index-pageWrapper-ykqiq",
	"mobile": "pages-company-index-mobile-bjqkf",
	"link": "pages-company-index-link-bugad",
	"title": "pages-company-index-title-bufyq",
	"image": "pages-company-index-image-bbcqc"
};
module.exports = ___CSS_LOADER_EXPORT___;
